import { render, staticRenderFns } from "./passo8.vue?vue&type=template&id=3b5179ac&scoped=true&"
import script from "./passo8.vue?vue&type=script&lang=js&"
export * from "./passo8.vue?vue&type=script&lang=js&"
import style0 from "./passo8.vue?vue&type=style&index=0&id=3b5179ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5179ac",
  null
  
)

export default component.exports